module.exports = __webpack_public_path__ + "static/media/img_high_potential_02.bb1a4e3f.png";